import './DatePickerInput.css';

interface DatePickerInputProps {
  label?: string;
  value: string;
  onChange: (date: string) => void;
  required?: boolean;
  error?: string;
  placeholder?: string;
  minimumDate?: Date;
  maximumDate?: Date;
}

export function DatePickerInput({
  label,
  value,
  onChange,
  required = false,
  error,
  placeholder = "Select date",
  minimumDate,
  maximumDate
}: DatePickerInputProps) {
  return (
    <div className="date-picker-container">
      {label && (
        <div className="date-picker-label-container">
          <label className="date-picker-label">
            {label}
            {required && <span className="date-picker-required"> *</span>}
          </label>
        </div>
      )}
      <input
        type="date"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`date-picker-input ${error ? 'date-picker-input-error' : ''}`}
        min={minimumDate?.toISOString().split('T')[0]}
        max={maximumDate?.toISOString().split('T')[0]}
        placeholder={placeholder}
      />
      {error && (
        <div className="date-picker-error-container">
          <span className="date-picker-error-text">⚠️ {error}</span>
        </div>
      )}
    </div>
  );
}
